/** A link that leaves the app (2026-09-11).
 *
 * `<a target="_blank">` is dead in the Teacher Computer app for the same reason `window.open`
 * is: the webview asks the shell to create a second web view and, with no handler supplied,
 * the answer is "no" and the click does nothing. Readings and the Telegram link were all
 * plain `target="_blank"` anchors, so on the desktop they were silent.
 *
 * This stays a real anchor -- the href is there for the middle click, the context menu and the
 * screen reader -- and only intercepts the click where the platform needs it, handing the URL
 * to the desktop instead. In a browser it is the anchor it always was.
 */
import type { AnchorHTMLAttributes, ReactNode } from "react";

import { capabilities } from "../platform/capabilities";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "target" | "rel"> & {
  href: string;
  children: ReactNode;
};

export function ExternalLink({ href, children, onClick, ...rest }: Props) {
  return (
    <a
      {...rest}
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      onClick={(e) => {
        onClick?.(e);
        if (!capabilities.opener.native || e.defaultPrevented) return;
        e.preventDefault();
        void capabilities.opener.open(href);
      }}
    >
      {children}
    </a>
  );
}
